import { makeStyles } from '@material-ui/core/styles';

const useCreatePayeeStyles = makeStyles((theme) => ({
  fields: {
    paddingRight: "0rem"
  },
  heading: {
    marginRight: "20px",
    color: "#1fb6ad",
    display: "block",
    fontSize: "1.5rem",
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: "0px"
  },
  footer: {
    borderTop: "1px solid var(--components-color)",
    paddingTop: "1rem",
    paddingBottom: "1rem",
    marginRight: "2rem",
    marginLeft: "2rem",
    textAlign: "right"
  },
  dividerSpacing: {
    marginBottom: "20px"
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: "32px"
  }
}));

export default useCreatePayeeStyles;